<template>
  
    <v-dialog
        v-model="showStatus"
        persistent
        max-width="600"
      >
        <template >
          <v-card>
            <v-toolbar
              color="primary"
              dark
            >{{title}}</v-toolbar>
            <v-card-text style="padding: 0 5px;">
              <div class="dialog-content">{{content}}</div>
            </v-card-text>
            <v-card-actions class="justify-end">
              <v-btn
                text
                @click="cancel"
              >{{btns[0]}}</v-btn>
              <v-btn
                text
                @click="excute"
              >{{btns[1]}}</v-btn>
            </v-card-actions>
          </v-card>
        </template>
      </v-dialog>
    
  
  
    
</template>

<script>
export default {
  name: 'ConfirmDialog',

  data: () => ({
    showStatus: false,
    title: '',
    content: '',
    btns: []
  }),
  created: function() {
    this.progressValue = 0
  },
  methods: {
    confirm: function(title, content, btns, successCall) {
      let that = this
      that.showStatus = true
      that.title = title
      that.content = content
      that.btns = btns
      that.successCall =  successCall

    },
    excute: function() {
      this.successCall()
      this.showStatus = false
    },
    cancel: function() {
      this.showStatus = false
    }
    
  }

};
</script>

<style scoped>
  .dialog-content {
    font-size: 16px;
    color: #222222;
    word-break: break-all;
    padding: 10px;
  }
</style>
